/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PartNumberChangeReportResultDetailModel} from '../../../api/ms-partnumberchanges/contracts/part-number-change-export-excel/models/part-number-change-report-result-detail.model';
import {PartNumberChangeReportDetailContract} from '../../../api/ms-partnumberchanges/contracts/part-number-change-export-excel/contracts/part-number-change-report-detail.contract';

export class PartNumberChangeReportResultDataMapper {

    private constructor() {
    }

    static fromPartNumberChangeReportDetailContractToPartNumberChangeReportResultModelArray(input: PartNumberChangeReportDetailContract[]):
            PartNumberChangeReportResultDetailModel[] {
        return input?.map((element) => PartNumberChangeReportResultDataMapper
                .fromPartNumberChangeReportDetailContractToPartNumberChangeReportResultModel(element));
    }

    static fromPartNumberChangeReportDetailContractToPartNumberChangeReportResultModel(input: PartNumberChangeReportDetailContract):
            PartNumberChangeReportResultDetailModel {
        if (input != null) {
            return {
                supplyingPackingPlant: input.supplyingPackingPlant,
                shipToParty: input.shipToParty,
                typeName: input.typeName,
                number: input.number,
                createdBy: input.createdBy,
                creationDatetime: input.creationDatetime,
                partner: input.partner,
                user: input.user,
                lastChangeDatetime: input.lastChangeDatetime,
                material: input.material,
                statusName: input.statusName,
                technicianGroupName: input?.technicianGroupName,
                newMaterial: input?.newMaterial?.material,
                newMaterialQuantity: input?.newMaterial?.quantity,
                additionalInformation: input?.additionalInformation
            };
        }
    }
};
